import axios from 'axios';
import fnc from '../mymod/commFunction';

const serverUrl = (process.env.REACT_APP_SERVER_URL
  || (process.env.NODE_ENV === 'development' ? 'http://localhost:8002' : '')).replace(/\/$/, '');

async function requestRows(path, data, authenticated = true) {
  const token = fnc.getCookie('appSessionToken');
  if (authenticated && !token) throw new Error('다시 로그인한 뒤 학습 리포트를 확인해 주세요.');

  try {
    const response = await axios.post(`${serverUrl}${path}`, data, {
      headers: authenticated ? { Authorization: `Bearer ${token}` } : {},
      timeout: 20000,
    });
    if (authenticated && fnc.getCookie('appSessionToken') !== token) {
      throw new Error('로그인 정보가 변경되었습니다. 다시 학습 리포트를 확인해 주세요.');
    }
    if (!Array.isArray(response.data)) {
      throw new Error(response.data?.error?.message || response.data?.error || '학습 정보를 불러오지 못했습니다.');
    }
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error?.message || error.response?.data?.error;
    if (typeof message === 'string') throw new Error(message);
    if (error.response?.status === 401) throw new Error('로그인이 만료되었습니다. 다시 로그인해 주세요.');
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
      throw new Error('학습 정보를 불러오지 못했습니다. 잠시 후 다시 확인해 주세요.');
    }
    throw error;
  }
}

export const fetchReportChildren = () => requestRows('/select/lms/report/guardian/children', {});

export function fetchReportClasses({ isParent, studentId }) {
  if (isParent) return requestRows('/select/lms/report/guardian/classes', { studentId });
  return requestRows('/select/lms/treeview', {
    acaCode: fnc.getCookie('acaCode'),
    stCode: fnc.getCookie('stCode'),
    db: fnc.getCookie('acaDbName'),
  }, false);
}

export function fetchReportRows({ isParent, studentId, classCode, startDate, endDate }) {
  const data = { classCode, startDate, endDate };
  if (isParent) data.studentId = studentId;
  return requestRows(isParent ? '/select/lms/report/guardian/student' : '/select/lms/report/student', data);
}
